<template>
    <div class="loading d-flex text-center">
        <div class="loading-animation m-auto">
            <svg class="icon icon-loader" width="32" height="32" fill="currentColor">
                <use xlink:href="#loader" />
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            template: {
                default: "#vue-loading-animation",
                type: String
            }
        }
    }
</script>
